import { ExtranetOrderListItemDto } from '@pharmac-extranet/extranet-api'
import { useState } from 'react'

type OrderCheckboxesHookState = {
  [groupIdCreatedAt: string]: Array<number>
}

export const useOrderCheckboxes = () => {
  const [state, set] = useState<OrderCheckboxesHookState>({})

  const toggleOrderCheckbox = (
    { groupId, createdAt }: ExtranetOrderListItemDto,
    orderId: number
  ) => {
    const exists: number[] | false = state[groupId + createdAt] ?? false

    set((s) => {
      if (!exists) return { ...s, [groupId + createdAt]: [orderId] }

      return {
        ...s,
        [groupId + createdAt]: exists.includes(orderId)
          ? exists.filter((a) => a !== orderId)
          : exists.concat(orderId),
      }
    })
  }

  const toggleGroupCheckboxes = (
    { groupId, createdAt }: ExtranetOrderListItemDto,
    orderIds: Array<number>
  ) => {
    const exists: number[] | false = state[groupId + createdAt] ?? false

    set((s) => {
      if (exists.length === orderIds.length) return { ...s, [groupId + createdAt]: [] }
      return {
        ...s,
        [groupId + createdAt]: orderIds,
      }
    })
  }

  return {
    checkboxes: state,
    toggleOrderCheckbox,
    toggleGroupCheckboxes,
  }
}
